import { render, staticRenderFns } from "./ColumnListPage.vue?vue&type=template&id=083c762e&scoped=true"
import script from "./ColumnListPage.vue?vue&type=script&lang=js"
export * from "./ColumnListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c762e",
  null
  
)

export default component.exports